// extracted by mini-css-extract-plugin
export default {"combinerContainer":"Combiner_combinerContainer__+z0ko","button":"Combiner_button__FAAWO","operator":"Combiner_operator__gfmZt"};